/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
import logLevel from 'loglevel';
export class Logger {
    name;
    logger;
    /**
     * This method is the correct way to obtain a logger.
     * @param name The logger name, for example: UserService.ts
     * @param level The logger level, see LogSeverity
     */
    static get(name, level = 'warn') {
        const internalLogger = logLevel.getLogger(name);
        internalLogger.setLevel(level);
        return new Logger(name, internalLogger);
    }
    static setGlobalLevel(level) {
        logLevel.setLevel(level);
        logLevel.setDefaultLevel(level);
    }
    constructor(name, logger) {
        this.name = name;
        this.logger = logger;
    }
    disable() {
        this.logger.setLevel('silent');
    }
    log(message, data) {
        this.logger.log(message, data || '');
    }
    debug(message, data) {
        this.logger.debug(this.normalizeMessage(message), data || '');
    }
    info(message, data) {
        this.logger.info(this.normalizeMessage(message), data || '');
    }
    warn(message, data) {
        this.logger.warn(this.normalizeMessage(message), data || '');
    }
    error(message, data) {
        this.logger.error(this.normalizeMessage(message), data || '');
    }
    normalizeMessage(message) {
        return `[${new Date().toISOString()}][${this.name}] ${message}`;
    }
}
//# sourceMappingURL=Logger.js.map